/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speakers_Wrapper_Aria_LabelInputs */

const en_speakers_wrapper_aria_label = /** @type {(inputs: Speakers_Wrapper_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speaker management`)
};

const fr_speakers_wrapper_aria_label = /** @type {(inputs: Speakers_Wrapper_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestion des intervenants`)
};

const de_speakers_wrapper_aria_label = /** @type {(inputs: Speakers_Wrapper_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprechermanagement`)
};

const it_speakers_wrapper_aria_label = /** @type {(inputs: Speakers_Wrapper_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestione degli altoparlanti`)
};

const ru_speakers_wrapper_aria_label = /** @type {(inputs: Speakers_Wrapper_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`управление спикерами`)
};

const es_speakers_wrapper_aria_label = /** @type {(inputs: Speakers_Wrapper_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestión de oradores`)
};

const zh_cn2_speakers_wrapper_aria_label = /** @type {(inputs: Speakers_Wrapper_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`演讲者管理`)
};

const ja_speakers_wrapper_aria_label = /** @type {(inputs: Speakers_Wrapper_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スピーカー管理`)
};

const hi_speakers_wrapper_aria_label = /** @type {(inputs: Speakers_Wrapper_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वक्ता प्रबंधन`)
};

const pt_pt2_speakers_wrapper_aria_label = /** @type {(inputs: Speakers_Wrapper_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestão de palestrantes`)
};

/**
* | output |
* | --- |
* | "Speaker management" |
*
* @param {Speakers_Wrapper_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speakers_wrapper_aria_label = /** @type {((inputs?: Speakers_Wrapper_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speakers_Wrapper_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_speakers_wrapper_aria_label(inputs)
	if (locale === "de") return de_speakers_wrapper_aria_label(inputs)
	if (locale === "it") return it_speakers_wrapper_aria_label(inputs)
	if (locale === "ru") return ru_speakers_wrapper_aria_label(inputs)
	if (locale === "es") return es_speakers_wrapper_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_speakers_wrapper_aria_label(inputs)
	if (locale === "ja") return ja_speakers_wrapper_aria_label(inputs)
	if (locale === "hi") return hi_speakers_wrapper_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_speakers_wrapper_aria_label(inputs)
	return en_speakers_wrapper_aria_label(inputs)
});